module.exports = __webpack_public_path__ + "media/images/core_values/passion-0b4137933c0b03234b92aea12c9f60d0.png";